import { normalizeRole, ROLE_ADMIN, ROLE_PARENT, ROLE_PRINCIPAL, ROLE_SCHOOL, ROLE_STAFF, ROLE_STUDENT, ROLE_SUPER_ADMIN, ROLE_TEACHER, ROLE_USER } from "../utils/authRole";

const shared = [
  { title: "Home", description: "Return to your role dashboard and recent activity.", path: "/" },
  { title: "Moments", description: "View and share school community updates.", path: "/moments" },
  { title: "Profile & security", description: "Review your profile and manage password settings.", path: "/profile" },
];

const management = [
  { title: "Student management", description: "Create student records and manage admission and fee status.", path: "/admin/students" },
  { title: "Teacher management", description: "Manage teachers, assignments, invitations, and payroll.", path: "/admin/teachers" },
  { title: "Classes & timetable", description: "Configure classes, subjects, teachers, and weekly schedules.", path: "/admin/class-subjects" },
  { title: "Fees", description: "Create fee records and monitor collections and pending payments.", path: "/admin/fees" },
  { title: "Notifications", description: "Compose, schedule, and track school announcements.", path: "/admin/notifications" },
];

export const getGuideFeatures = (rawRole) => {
  const role = normalizeRole(rawRole);
  if (role === ROLE_SUPER_ADMIN) return [
    { title: "Super Admin dashboard", description: "Review platform activity and open the tenant portfolio.", path: "/super-admin" },
    { title: "Tenant directory", description: "Manage tenant accounts, status, plans, and platform subscriptions.", path: "/super-admin?panel=tenantPortfolio" },
    { title: "Platform metrics", description: "Review visitor activity and platform usage signals.", path: "/super-admin/platform-metrics" },
    { title: "Employee management", description: "Manage ClassNX employee accounts and invitations.", path: "/super-admin/employees" },
    ...shared,
  ];
  if ([ROLE_ADMIN, ROLE_SCHOOL].includes(role)) return [...management, ...shared];
  if (role === ROLE_TEACHER) return [
    { title: "Teacher dashboard", description: "Access classes, attendance, assessments, and student activity.", path: "/teacher-dashboard" },
    { title: "Attendance", description: "Select a class and record or correct daily attendance.", path: "/teacher-dashboard" },
    ...shared,
  ];
  if (role === ROLE_PRINCIPAL) return [{ title: "Principal dashboard", description: "Review school operations, academics, and financial trends.", path: "/principal" }, ...shared];
  if ([ROLE_STUDENT, ROLE_USER].includes(role)) return [{ title: "Student dashboard", description: "Find classes, assessments, fees, and learning activity.", path: "/user-dashboard" }, ...shared];
  if (role === ROLE_PARENT) return [{ title: "Parent dashboard", description: "Follow linked students, school updates, and academic information.", path: "/user-dashboard" }, ...shared];
  return shared;
};
